// extracted by extract-css-chunks-webpack-plugin
module.exports = {"split-flap-price":"VpBeZguYUhI4qz2e3znf","thousands":"SaPe8kyhwhn2WLtlFz7f","millions":"jDTsVNDtgxpVS1IG00d9"};